export enum PokerVariant {
  NoLimitTexasHoldem = 'NoLimitTexasHoldem',
  NoLimitTexasHoldemCapped = 'NoLimitTexasHoldemCapped',
  NoLimitShortDeckHoldem = 'NoLimitShortDeckHoldem',
  FixedLimitTexasHoldem = 'FixedLimitTexasHoldem',
  PotLimitOmaha = 'PotLimitOmaha',
  PotLimitOmahaCapped = 'PotLimitOmahaCapped',
  PotLimitOmahaEightOrBetter = 'PotLimitOmahaEightOrBetter',
  PotLimitOmahaEightOrBetterCapped = 'PotLimitOmahaEightOrBetterCapped',
  PotLimitDoubleBoardOmaha = 'PotLimitDoubleBoardOmaha',
  FixedLimitOmahaHigh = 'FixedLimitOmahaHigh',
  FixedLimitOmahaEightOrBetter = 'FixedLimitOmahaEightOrBetter',
  FixedLimitDoubleBoardOmaha = 'FixedLimitDoubleBoardOmaha',
  PotLimitFiveCardOmaha = 'PotLimitFiveCardOmaha',
  PotLimitFiveCardOmahaEightOrBetter = 'PotLimitFiveCardOmahaEightOrBetter',
  PotLimitFiveCardOmahaCapped = 'PotLimitFiveCardOmahaCapped',
  PotLimitFiveCardOmahaEightOrBetterCapped = 'PotLimitFiveCardOmahaEightOrBetterCapped',
  PotLimitFiveCardDoubleBoardOmaha = 'PotLimitFiveCardDoubleBoardOmaha',
  PotLimitSixCardOmaha = 'PotLimitSixCardOmaha',
  PotLimitSixCardOmahaCapped = 'PotLimitSixCardOmahaCapped',
  PotLimitSixCardDoubleBoardOmaha = 'PotLimitSixCardDoubleBoardOmaha',
  PotLimitSixCardOmahaEightOrBetter = 'PotLimitSixCardOmahaEightOrBetter',
  PotLimitSixCardOmahaEightOrBetterCapped = 'PotLimitSixCardOmahaEightOrBetterCapped',
  NoLimitOmahaEightOrBetter = 'NoLimitOmahaEightOrBetter',
  FixedLimitFiveCardOmahaEightOrBetter = 'FixedLimitFiveCardOmahaEightOrBetter',
  FixedLimitFiveCardDoubleBoardOmaha = 'FixedLimitFiveCardDoubleBoardOmaha',
  FixedLimitSevenCardStud = 'FixedLimitSevenCardStud',
  FixedLimitStudEightOrBetter = 'FixedLimitStudEightOrBetter',
  FixedLimitStudHighLowRegular = 'FixedLimitStudHighLowRegular',
  FixedLimitRazz = 'FixedLimitRazz',
  FixedLimitDeuceToSevenRazz = 'FixedLimitDeuceToSevenRazz',
  FixedLimitBadugi = 'FixedLimitBadugi',
  FixedLimitBadeucy = 'FixedLimitBadeucy',
  FixedLimitBadacey = 'FixedLimitBadacey',
  FixedLimitAceToFiveLowballTripleDraw = 'FixedLimitAceToFiveLowballTripleDraw',
  FixedLimitDeuceToSevenLowballTripleDraw = 'FixedLimitDeuceToSevenLowballTripleDraw',
  FixedLimitArchieSixesHighEightOrBetter = 'FixedLimitArchieSixesHighEightOrBetter',
  FixedLimitArchieNinesHighEightOrBetter = 'FixedLimitArchieNinesHighEightOrBetter',
  FixedLimitDramahaBadugi = 'FixedLimitDramahaBadugi',
  FixedLimitDramahaHigh = 'FixedLimitDramahaHigh',
  FixedLimitDeuceToSevenDramaha = 'FixedLimitDeuceToSevenDramaha',
  NoLimitDeuceToSevenLowballSingleDraw = 'NoLimitDeuceToSevenLowballSingleDraw',
  NoLimitDeuceToSevenLowballSingleDrawCapped = 'NoLimitDeuceToSevenLowballSingleDrawCapped',

  // Bomb Pot variants
  NoLimitTexasHoldemBombPot = 'NoLimitTexasHoldemBombPot',
  NoLimitTexasHoldemDoubleBoardBombPot = 'NoLimitTexasHoldemDoubleBoardBombPot',
  PotLimitOmahaBombPot = 'PotLimitOmahaBombPot',
  PotLimitOmahaDoubleBoardBombPot = 'PotLimitOmahaDoubleBoardBombPot',
  PotLimitFiveCardOmahaBombPot = 'PotLimitFiveCardOmahaBombPot',
  PotLimitFiveCardOmahaDoubleBoardBombPot = 'PotLimitFiveCardOmahaDoubleBoardBombPot',
  PotLimitSixCardOmahaBombPot = 'PotLimitSixCardOmahaBombPot',
  PotLimitSixCardOmahaDoubleBoardBombPot = 'PotLimitSixCardOmahaDoubleBoardBombPot',
}
